export const DEFAULT_ISSUER = `${import.meta.env.VITE_AUTH_BASE_URL}/realms/${import.meta.env.VITE_AUTH_REALM}`;
export const DEFAULT_AUTHORITY = `${DEFAULT_ISSUER}/protocol/openid-connect/auth`;
export const DEFAULT_META_DATA_URL = `${DEFAULT_ISSUER}/.well-known/openid-configuration`;

export const COOKIES_PROFILE_HOST_KEY = 'PROFILE_HOST';
export const LOCAL_STORAGE_PROFILE_HOST_KEY = COOKIES_PROFILE_HOST_KEY;

export const SESSION_STORAGE_ONBOARDING_ACCESS_TOKEN_KEY =
	'onboarding-access-token';

export enum SSOProvider {
	UNSPECIFIED = 'SSO_PROVIDER_UNSPECIFIED',
	MICROSOFT = 'SSO_PROVIDER_MICROSOFT',
}
